import { useTranslation } from '@mint-lib/i18n';
import { Stop } from '@mint-lib/icons';
import { cn } from '@mint-lib/tw-utils';

import { Button } from '../../lib/button.jsx';
import { CircularLoadingButton } from '../../lib/progress.jsx';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../lib/tooltip.jsx';

type Props = {
  onClick?: () => void;
  isLoading?: boolean;
};

const ChatStop = ({ onClick, isLoading }: Props) => {
  const { t } = useTranslation('@mint-lib/tw-components');

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          aria-label="Stop"
          onClick={onClick}
          variant="plain"
          className={cn(
            'text-primary size-14 gap-0 p-0',
            'focus:outline-none active:bg-ui-primary',
          )}
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularLoadingButton size="large" variant="contained" />
          ) : (
            <Stop className={cn('size-5')} />
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent sideOffset={10} side="top" align="center" arrow>
        {t('Stop request')}
      </TooltipContent>
    </Tooltip>
  );
};

export default ChatStop;
